@if (editMode) {
  <div
    class="field-selection">
    <div class="field">
      <label>{{ 'COMMUNICATIONS.DATASET' | translate }}</label>
      <div class="select is-primary is-fullwidth is-medium">
        <select
          [(ngModel)]="selectedDatasetUId"
          (change)="datasetChanged(true)">
          @for (dataset of datasets; track dataset.uId) {
            <option
              [ngValue]="dataset.uId">
              {{ dataset.name }}
            </option>
          }
        </select>
      </div>
    </div>
    <div class="field">
      <label>{{ 'COMMUNICATIONS.DATASET-FIELD' | translate }}</label>
      <div class="select is-primary is-fullwidth is-medium">
        <select
          [(ngModel)]="selectedSystemName"
          (change)="fieldChanged()">
          @for (field of fields; track field.systemName) {
            <option
              [ngValue]="field.systemName">
              {{ getFieldDisplayName(field) }}
            </option>
          }
        </select>
      </div>
    </div>
    <div class="field">
      <label>{{ 'COMMUNICATIONS.FIELD-NAME' | translate }}</label>
      <div>
        <input
          (ngModelChange)="nameChanged($event)"
          class="input is-small is-fullwidth"
          type="text"
          placeholder="{{ 'COMMUNICATIONS.FIELD-NAME' | translate }}"
          [(ngModel)]="selectedFieldName" />
      </div>
    </div>
  </div>
}
@if (!editMode && !!!hideFromPreview) {
  <div>
    <div style="min-height: 34px">
      <div class="field-name">
        {{ fieldDisplayName }}
      </div>
      <div class="field-value">
        @if (format !== TextFieldFormat.MultiLine) {
          <div
            class="single-line"
            >
            {{ fieldValue }}
          </div>
        }
        @if (format === TextFieldFormat.MultiLine) {
          <quill-view
            [content]="fieldValue"
          format="html"></quill-view>
        }
      </div>
    </div>
  </div>
}
